/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Agent_Schedule_Summary_DailyInputs */



/**
* | output |
* | --- |
* | "Every day at {time}" |
*
* @param {Agent_Schedule_Summary_DailyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_summary_daily = /** @type {((inputs: Agent_Schedule_Summary_DailyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Summary_DailyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Täglich um ${i?.time}`)
	return /** @type {LocalizedString} */ (`Every day at ${i?.time}`)
});